import React, {Component} from 'react';
import styles from './HeroTransitionSection.scss';
import classNames from 'classnames/bind';
import * as SceneEffects from '../../../../lib/functions/SceneEffects';

const cx = classNames.bind(styles);

class HeroTransitionSection extends Component {
  heroTransitionSectionRef;
  heroTransitionStatementRef;

  componentDidMount() {
    const {heroTransitionSectionRef, heroTransitionStatementRef} = this;

    SceneEffects.fadeInUp(heroTransitionSectionRef, heroTransitionStatementRef);
  }

  render() {
    return (
      <section className={cx('hero-transition')} ref={ref => this.heroTransitionSectionRef = ref}>
        <div className={cx('hero-transition__statement')} ref={ref => this.heroTransitionStatementRef = ref}>
          <p>屋内の空気は屋外と比べて最大５倍汚れている可能性があり、アレルギーや皮膚炎、ぜんそく、睡眠などに影響を与えていることがわかっています。</p>
        </div>
      </section>
    );
  }
}

export default HeroTransitionSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/HeroTransitionSection/HeroTransitionSection.js